import React from 'react';
import styled from 'styled-components';
import { grid } from '@finect/tabular-utils/grid';
export var ProgressBarBlock = styled.div.withConfig({
  displayName: "ProgressBar__ProgressBarBlock",
  componentId: "sc-zflca7-0"
})(["display:flex;align-items:center;flex-direction:column;padding:12px 30px 0;small{margin-bottom:6px;}"]);
var Inner = styled.div.withConfig({
  displayName: "ProgressBar__Inner",
  componentId: "sc-zflca7-1"
})(["display:flex;width:", "px;max-width:100%;height:6px;border-radius:6px;background-color:", ";"], grid(2), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.uiL;
});
var CurrentProgress = styled.div.withConfig({
  displayName: "ProgressBar__CurrentProgress",
  componentId: "sc-zflca7-2"
})(["width:", "%;height:6px;border-radius:6px;background-color:", ";transition:width 0.15s ease;"], function (_ref2) {
  var percentage = _ref2.percentage;
  return percentage;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.mainColor;
});
export var ProgressBar = function ProgressBar(_ref4) {
  var currentStep = _ref4.currentStep,
    steps = _ref4.steps;
  var percentage = currentStep * 100 / steps;
  return React.createElement(Inner, null, React.createElement(CurrentProgress, {
    percentage: percentage
  }));
};